<template>
  <b-card no-body>
    <!-- <b-card-header class="pb-50">
      <h5>
        Filters
      </h5>
    </b-card-header> -->
    <b-card-body>
      <b-row>
        <b-col cols="12" md="3" class="mb-md-0 mb-2">
          <label class="h5">Type</label>
          <v-select :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :value="typeFilter" :options="typeOptions"
            placeholder="Filter by Type" class="w-100" :reduce="val => val.value"
            @input="(val) => $emit('update:typeFilter', val)" />
        </b-col>
        <b-col cols="12" md="3" class="mb-md-0 mb-2">
          <label class="h5">Reviewer</label>
          <v-select :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :value="reviewerFilter"
            :options="reviewerOptions" placeholder="Filter by Reviewer" class="w-100" :reduce="val => val.value"
            @input="(val) => $emit('update:reviewerFilter', val)" />
        </b-col>
        <b-col cols="12" md="3" class="mb-md-0 mb-2">
          <label class="h5">Reviewee</label>
          <v-select :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :value="revieweeFilter"
            :options="revieweeOptions" placeholder="Filter by Reviewee" class="w-100" :reduce="val => val.value"
            @input="(val) => $emit('update:revieweeFilter', val)" />
        </b-col>
        <b-col cols="12" md="3" class="mb-md-0 mb-2">
          <label class="h5">Status</label>
          <v-select :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :value="statusFilter" :options="statusOptions"
            placeholder="Filter by Submission Status" class="w-100" :reduce="val => val.value"
            @input="(val) => $emit('update:statusFilter', val)" />
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
  },
  props: {
    typeFilter: {
      type: [String, null],
      default: null,
    },
    reviewerFilter: {
      type: [String, null],
      default: null,
    },
    revieweeFilter: {
      type: [String, null],
      default: null,
    },
    statusFilter: {
      type: [String, null],
      default: null,
    },
    typeOptions: {
      type: Array,
      required: true,
    },
    reviewerOptions: {
      type: Array,
      required: true,
    },
    revieweeOptions: {
      type: Array,
      required: true,
    },
    statusOptions: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
